module.exports = __webpack_public_path__ + "img/Project-w-collaborators-web.dbd814d8.png";